import React from 'react';

// Clickable strip of strategy versions from a builder chat's version_chain
// (see strategies/builder_chat.py:build_compare_versions_context). Hidden
// until there's more than one version to switch between.
export default function VersionTimeline({ versions, currentStrategyId, onSelect }) {
  if (!versions || versions.length < 2) return null;
  return (
    <div style={{
      display: 'flex',
      gap: 6,
      padding: '8px 12px',
      overflowX: 'auto',
      background: 'var(--card)',
      borderBottom: '1px solid var(--border)',
    }}>
      {versions.map((v) => {
        const active = v.strategy_id === currentStrategyId;
        return (
          <button
            key={v.strategy_id}
            onClick={() => onSelect && onSelect(v)}
            title={v.change_summary}
            style={{
              flexShrink: 0,
              padding: '4px 10px',
              borderRadius: 999,
              fontSize: 11,
              fontWeight: 600,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              background: active ? 'var(--teal)' : 'var(--surface)',
              color: active ? 'var(--bg)' : 'var(--text)',
              border: `1px solid ${active ? 'var(--teal)' : 'var(--border)'}`,
            }}
          >
            v{v.index}
          </button>
        );
      })}
    </div>
  );
}
